export const tableColumns = (ctx) => {
  console.log(ctx.pageMode, 'pageMode');
  return [
    {
      name: '标题',
      prop: 'title',
      type: 'input',
      span: 12,
      maxlength: 20,
    },
    {
      name: '类型',
      prop: 'type',
      type: 'select',
      options: [
        { value: '01', label: '通知' },
        { value: '02', label: '公告' },
      ],
      span: 12,
    },
    {
      name: '副标题',
      prop: 'subtitle',
      type: 'input',
      span: 24,
      maxlength: 20,
    },
    {
      name: '内容',
      prop: 'content',
      type: 'textarea',
      span: 24,
      maxlength: 500,
    },
    {
      name: '发布人',
      prop: 'issuerPersonNo',
      type: 'searchTableSpec',
      searchType: 'personnel',
      extraData: {
        adminFlag: ctx.userInfo.adminFlag,
        dataStatus: 'ZT03',
        personCompanyCode: ctx.userInfo.companyCode,
        // personDepartmentCode:ctx.userInfo.departmentCode
      },
      changeMethod: 'changeMethod',
      currentValue: ctx.baseInfoData.issuerPersonName,
      isMultiple: true,
      span: 12,
    },
    {
      name: '发布时间',
      prop: 'issuerDate',
      type: 'startDaterangePickerTime',
      span: 12,
    },
    {
      name: '创建人',
      prop: 'createPersonName',
      type: 'input',
      span: 12,
      isHidden: ctx.pageMode != 1,
    },
    {
      name: '创建时间',
      prop: 'gmtCreateShow',
      type: 'startDaterangePickerTime',
      span: 12,
      isHidden: ctx.pageMode != 1,
    },
  ];
};
